import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import { cn } from "@/lib/utils"

interface StreamingMarkdownProps {
  text: string
  isStreaming?: boolean
  className?: string
}

export function StreamingMarkdown({ text, isStreaming, className }: StreamingMarkdownProps) {
  return (
    <div
      aria-live={isStreaming ? "polite" : undefined}
      className={cn(
        // Base typography — bigger and more readable than before
        "text-xs leading-relaxed text-foreground/85 break-words",
        // Spacing between block elements
        "[&>*+*]:mt-2 [&>*:first-child]:mt-0",
        // Paragraphs
        "[&_p]:leading-relaxed",
        // Headings
        "[&_h1]:text-sm [&_h1]:font-semibold [&_h1]:mt-3 [&_h1:first-child]:mt-0",
        "[&_h2]:text-[13px] [&_h2]:font-semibold [&_h2]:mt-2.5 [&_h2:first-child]:mt-0",
        "[&_h3]:text-xs [&_h3]:font-semibold [&_h3]:mt-2 [&_h3:first-child]:mt-0",
        // Inline emphasis — prose reset strips these
        "[&_strong]:font-semibold [&_b]:font-semibold",
        "[&_em]:italic [&_i]:italic",
        // Lists — Tailwind preflight removes list-style; restore it
        "[&_ul]:list-disc [&_ul]:pl-4 [&_ul]:space-y-0.5",
        "[&_ol]:list-decimal [&_ol]:pl-4 [&_ol]:space-y-0.5",
        "[&_li]:leading-relaxed",
        // Inline code
        "[&_code]:text-[11px] [&_code]:font-mono [&_code]:bg-black/8 dark:[&_code]:bg-white/10 [&_code]:rounded [&_code]:px-1 [&_code]:py-px",
        // Code blocks (pre resets code styles inside)
        "[&_pre]:text-[11px] [&_pre]:font-mono [&_pre]:bg-black/8 dark:[&_pre]:bg-white/10 [&_pre]:rounded-lg [&_pre]:p-3 [&_pre]:overflow-x-auto",
        "[&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-inherit",
        // Blockquote
        "[&_blockquote]:border-l-2 [&_blockquote]:border-border/60 [&_blockquote]:pl-3 [&_blockquote]:italic [&_blockquote]:text-foreground/60",
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {text}
      </ReactMarkdown>
    </div>
  )
}
